<main-nav>
  <div class="main-content-container">
    <router-outlet></router-outlet>
  </div>
</main-nav>
